import React from 'react'
import PropTypes from 'prop-types'
import {
  Modal,
  ModalBody,
  ModalHeader,
  Button
} from 'reactstrap';
import pickBy from 'lodash/pickBy';
import { FaPencilAlt } from 'react-icons/fa'

// @Constants
import { LABELS_PROGRAMA } from '../ProgramaStepForm/constantes';

export const ModalVerInfoPrograma = ({ programa, onToggle, open, onEditarPrograma }) => {
  
  const fieldsToDisplay = pickBy(programa, (value, key) =>
    !!LABELS_PROGRAMA[key] && value !== null);

  return (
    <Modal
      isOpen={open}
      toggle={onToggle}
      size='lg'
      unmountOnClose
    >
      <ModalHeader toggle={onToggle}>
        Detalles del programa
        <span title='Editar Programa'> 
        <Button
          outline
          color='primary'
          size='sm'
          className='mr-1'
          onClick={onEditarPrograma}
          style={{ marginLeft: '1rem' }}
        >
          <FaPencilAlt />
          </Button>
        </span>
      </ModalHeader>
      <ModalBody>
        {Object.entries(fieldsToDisplay).map(([field, value], index) => (
          <div
            key={index}
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              padding: '10px',
            }}
          >
            <strong>{LABELS_PROGRAMA[field]}:</strong> <span>{value}</span>
          </div>
        ))}
      </ModalBody>
    </Modal>
  )
}

ModalVerInfoPrograma.propTypes = {
  programa: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onEditarPrograma: PropTypes.func.isRequired,
}

ModalVerInfoPrograma.defaultProps = {
  programa: {},
  onToggle: () => { },
  open: false,
  onEditarPrograma: () => { },
}
